/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {
  useEffect,
  useState,
  useMemo,
  ReactElement,
  useContext,
} from "react";
import {
  Button,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Badge,
} from "@chakra-ui/react";
import { FaAngleLeft, FaPlus } from "react-icons/fa";
import { AgGridReact } from "ag-grid-react";
import { ColDef, ICellRendererParams, ModuleRegistry, AllCommunityModule, themeAlpine } from "ag-grid-community";
import axios from "axios";
import { Box } from "@chakra-ui/react";
import AddRoleModal from "./components/modal/AddRoleModal";
import EditRoleModal from "./components/modal/EditRoleModal";
import DeleteRoleModal from "./components/modal/DeleteRoleModal";
import InputField from "components/fields/InputField";
import SweetAlert2 from "react-sweetalert2";
import { useParams, useNavigate } from "react-router-dom";
import { Auth } from "aws-amplify";
import moment from "moment";
import { AiOutlineForm, AiOutlineClose } from "react-icons/ai";
import { Tooltip, IconButton, CircularProgress } from "@mui/material";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { MdOutlineRestartAlt } from "react-icons/md";
import { MdOutlineDoNotDisturbAlt } from "react-icons/md";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { Spinner } from "@chakra-ui/react";
import { ImSpinner8 } from "react-icons/im";

import UserUpdateStatusConfirmModal from "../shared/UserUpdateStatusConfirmModal";
import UserResetTwoFactorConfirmModal from "./components/modal/UserResetTwoFactorConfirmModal";
import UserUpdateTwoFactorStatusConfirmModal from "./components/modal/UserUpdateTwoFactorStatusConfirmModal";
import Card from "components/card";

import { ProfileContext } from "../../../store/ProfileProvider";

dayjs.extend(utc);
dayjs.extend(timezone);

ModuleRegistry.registerModules([AllCommunityModule]);

const editUserChannel = new BroadcastChannel("edit-user-update");

type UserRole = {
  role: string;
  merchantId: string;
  subaccountId: string;
};

const rowPerPage = 10;

const UserDetail = () => {
  const { profileTimeZone } = useContext(ProfileContext);
  const navigate = useNavigate();
  const userRole = localStorage.getItem("userRole")?.toLowerCase();
  const sysUsername = localStorage.getItem("username")?.toLowerCase();
  const subaccountId = localStorage.getItem("subaccountId")?.toLowerCase();
  const userid = localStorage.getItem("userid")?.toLowerCase();
  const { user_id } = useParams();
  const [userDetail, setUserDetail] = useState(null);
  const [userRoles, setUserRoles] = useState<UserRole[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isProcessing, setIsProcessing] = useState(true);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isSetSubaccounts, setIsSetSubaccounts] = useState(false);
  const [isOpenAddRoleModal, setIsOpenAddRoleModal] = useState(false);
  const [isOpenEditRoleModal, setIsOpenEditRoleModal] = useState(false);
  const [isOpenDeleteRoleModal, setIsOpenDeleteRoleModal] = useState(false);
  const [selectedRole, setSelectedRole] = useState<UserRole | null>(null);
  const [twoFactorStatus, setTwoFactorStatus] = useState<boolean>(false);

  const [updatedUser, setUpdatedUser] = useState({
    username: "",
    email: "",
  });
  const [isUpdating, setIsUpdating] = useState(false);
  const [swalProps, setSwalProps] = useState<any>({});

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(rowPerPage);
  const [roleHierarchy, setRoleHierarchy] = useState([]);
  const [merchants, setMerchants] = useState([]);
  const [merchantForGetNameList, setMerchantForGetNameList] = useState([]);
  const [deleteRoleMerchantName, setDeleteRoleMerchantName] =
    useState<string>("");
  const [deleteRoleSubaccountName, setDeleteRoleSubaccountName] =
    useState<string>("");
  const [roleOptions, setRoleOptions] = useState<string[]>([]);
  const [editRoleOptions, setEditRoleOptions] = useState<string[]>([]);
  const currentUserRole = localStorage.getItem("userRole");

  const [isOpenUpdateStatusConfirmModal, setIsOpenUpdateStatusConfirmModal] =
    useState<boolean>(false);
  const [statusToUpdate, setStatusToUpdate] = useState<string>("");

  const [
    isOpenResetTwoFactorConfirmModal,
    setIsOpenResetTwoFactorConfirmModal,
  ] = useState<boolean>(false);

  const [
    isOpenUpdateTwoFactorStatusConfirmModal,
    setisOpenUpdateTwoFactorStatusConfirmModal,
  ] = useState<boolean>(false);
  const [twoFactorStatusToUpdate, setTwoFactorStatusToUpdate] =
    useState<string>("");

  const formatDate = (dateString: string) => {
    return moment(dateString, "YYYY-MM-DD HH:mm:ss").format(
      "DD MMM YY - hh:mm A"
    );
  };

  const setPaginationModel = (newValue: any) => {
    setPage(newValue.page);
    setPageSize(newValue.pageSize);
  };

  const handleAddRole = () => {
    setIsOpenAddRoleModal(true);
  };

  const closeAddRoleModal = () => {
    setIsOpenAddRoleModal(false);
  };

  const handleEditRole = (role: UserRole) => {
    setSelectedRole(role);
    setIsOpenEditRoleModal(true);
  };

  const closeEditRoleModal = () => {
    setIsOpenEditRoleModal(false);
  };

  const handleDeleteRole = (role: UserRole) => {
    setSelectedRole(role);

    const merchant = merchantForGetNameList.find((x: any) => x.id === role.merchantId);
    setDeleteRoleMerchantName(merchant ? merchant.name : "");

    let subaccountName = "";
    if (merchant && merchant.subaccount) {
      const subaccount = merchant.subaccount.find((s: any) => s.id === role.subaccountId);
      subaccountName = subaccount ? subaccount.name : "";
    }
    setDeleteRoleSubaccountName(subaccountName);

    setIsOpenDeleteRoleModal(true);
  };

  const closeDeleteRoleModal = () => {
    setIsOpenDeleteRoleModal(false);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setUpdatedUser((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));
  };

  const isValidEmail = (email: string) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const handleUpdateUser = async () => {
    setIsUpdating(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/${userRole}/user/action/user-general-update`,
        {
          ...updatedUser,
          originalEmail: userDetail.email,
          userRole: userRole,
          sysUsername: sysUsername,
          subaccountId: subaccountId,
          fn: "general",
        }
      );
      setSwalProps({
        show: true,
        icon: "success",
        title: "Success",
        html: "User information successfully updated!",
        showConfirmButton: true,
        didClose: () => {
          fetchUserDetail();
          setSwalProps({});
          setIsUpdating(false);
        },
      });
    } catch (error: any) {
      console.error("Error updating user:", error.response.data);
      setSwalProps({
        show: true,
        icon: "error",
        title: "Oops!",
        html: "Failed to update user. Username or Email already existed.",
        showConfirmButton: true,
        didClose: () => {
          setSwalProps({});
          setIsUpdating(false);
        },
      });
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      await fetchUserDetail();
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const roles = await fetchUserRoles();
      await fetchHierarchy();
      await getMerchantOptions();
      if (roles && roles.length > 0) {
        await getMerchantAndSubaccountNames(roles);
      }
      await getRoleOptions();
      setIsLoading(false);
    };

    if (userDetail !== null) {
      fetchData();
    }
  }, [userDetail]);

  const fetchUserDetail = async () => {
    try {
      setIsProcessing(true);

      const response = await axios.get(
        process.env.REACT_APP_API_URL +
          `/api/user/get-user-detail?user_id=${user_id}`
      );

      let userData = response.data.user;

      // Check if user data exists, if not redirect to user management listing
      if (!userData) {
        console.error("User not found");
        navigate(`/${userRole}/user-management`);
        return;
      }

      setUserDetail({
        ...userData,
        agentName: localStorage.getItem("agentName"),
      });

      const userFormData = {
        ...updatedUser,
        username: userData.username,
        email: userData.email,
        agentName: localStorage.getItem("agentName") || "",
      };
      setUpdatedUser(userFormData);
      setIsLoading(false);
      setIsProcessing(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching data", error);
      // Redirect to user management listing page on error
      navigate(`/${userRole}/user-management`);
    }
  };

  const fetchUserRoles = async (manualReload: boolean = false) => {
    try {
      if (manualReload) {
        setIsLoading(true);
      }

      const response = await axios.get(
        `${
          process.env.REACT_APP_API_URL
        }/api/user/get-all-user-roles?email=${encodeURIComponent(
          userDetail.email
        )}`
      );

      let newData = response.data;

      if (newData.length !== 0) {
        setUserRoles(newData);
      } else {
        setUserRoles([]);
      }

      if (manualReload) {
        if (newData.length > 0) {
          await getMerchantAndSubaccountNames(newData);
        }
        setIsLoading(false);
      }

      return newData;
    } catch (error) {
      setUserRoles([]);
      setIsLoading(false);
      setPage(0);
      setPageSize(0);
      console.error("Error fetching data", error);
      console.error("Error fetching user roles:", error);
      return [];
    }
  };

  const fetchHierarchy = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL + "/api/user/get-all-hierarchy-levels"
      );

      setRoleHierarchy(response.data);
    } catch (error) {
      console.error("Error fetching hierarchy data", error);
      setRoleHierarchy([]);
    }
  };

  const getMerchantOptions = async () => {
    let merchantsOptionsArray = [];
    try {
      if (currentUserRole === "SuperAdmin") {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/merchant/all-merchants`
        );
        if (response.data.merchants && response.data.merchants.payload) {
          merchantsOptionsArray = [
            { id: "", name: "-- Please Select --" },
            ...response.data.merchants.payload,
          ];
        } else {
          console.error("Invalid response format for get-all-merchants");
          merchantsOptionsArray = [{ id: "", name: "-- Please Select --" }];
        }
      } else {
        const session = await Auth.currentSession();
        const idToken = session.getIdToken();
        const cognitoId = idToken.payload.sub;

        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/merchant/get-merchants-for-user?cognitoId=${cognitoId}`
        );

        if (response.data.merchants && response.data.merchants.payload) {
          merchantsOptionsArray = [
            { id: "", name: "-- Please Select --" },
            ...response.data.merchants.payload,
          ];
        } else {
          console.error("Invalid response format for get-merchants-for-user");
          merchantsOptionsArray = [{ id: "", name: "-- Please Select --" }];
        }
      }

      setMerchants(merchantsOptionsArray);
    } catch (error) {
      setIsLoading(false);
      console.error(error);
      setMerchants([]);
    }
  };

  const getSubaccountOptions = async (merchantId: any) => {
    setIsSetSubaccounts(true);
    try {
      if (currentUserRole === "SuperAdmin") {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/subaccount/get-all-subaccounts-for-merchant?merchantId=${merchantId}`
        );

        setIsSetSubaccounts(false);

        return [
          { id: "", suba_name: "-- Please Select --" },
          ...response.data?.subaccounts,
        ];
      } else {
        const session = await Auth.currentSession();
        const idToken = session.getIdToken();
        const cognitoId = idToken.payload.sub;

        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/subaccount/get-all-subaccounts-user?cognitoId=${cognitoId}&merchantId=${merchantId}`
        );

        setIsSetSubaccounts(false);

        return [
          { id: "", suba_name: "-- Please Select --" },
          ...response.data.subaccounts.payload,
        ];
      }
    } catch (error) {
      setIsSetSubaccounts(false);
      console.error(error);
      return [];
    }
  };

  const getMerchantAndSubaccountNames = async (roles: UserRole[]) => {
    try {
      const ids = [...new Set(roles.map((r) => r.merchantId).filter(Boolean))].join(",");
      const subaccountIds = [...new Set(roles.map((r) => r.subaccountId).filter(Boolean))].join(",");

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/merchant/all-merchants?ids=${ids}&subaccount_ids=${subaccountIds}&include_subaccount=true`
      );

      if (response.data.merchants && response.data.merchants.payload) {
        setMerchantForGetNameList(response.data.merchants.payload);
      } else {
        setMerchantForGetNameList([]);
      }
    } catch (error) {
      console.error(error);
      setMerchantForGetNameList([]);
    }
  };

  const getRoleOptions = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/user/get-all-hierarchy-levels`
      );
      const roles = response.data;

      const currentRole = roles.find(
        (role: any) => role.name === currentUserRole
      );

      if (!currentRole) {
        return ["-- Please Select --"];
      }

      const roleOptionsArray = ["-- Please Select --"];
      roles.forEach((role: any) => {
        if (role.hierarchy_level !== 4 && role.hierarchy_level !== 3 && (userDetail?.isAgent || role.hierarchy_level !== 8)) {
          roleOptionsArray.push(role.name);
        }
      });
      setRoleOptions(roleOptionsArray);

      const editRoleOptionsArray = ["-- Please Select --"];
      roles.forEach((role: any) => {
        if (
          role.hierarchy_level !== 4 &&
          role.hierarchy_level !== 3 &&
          role.hierarchy_level !== 8
        ) {
          editRoleOptionsArray.push(role.name);
        }
      });
      setEditRoleOptions(editRoleOptionsArray);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching role options:", error);
      setRoleOptions([]);
      setEditRoleOptions([]);
    }
  };

  const MerchantNameRenderer = (params: ICellRendererParams) => {
    const merchantId = params.data.merchantId;
    const merchant = merchantForGetNameList.find((x: any) => x.id === merchantId);
    return <>{merchant ? merchant.name : ""}</>;
  };

  const SubaccountNameRenderer = (params: ICellRendererParams) => {
    const merchantId = params.data.merchantId;
    const subaccountId = params.data.subaccountId;
    const merchant = merchantForGetNameList.find((x: any) => x.id === merchantId);
    if (!merchant || !merchant.subaccount) return <></>;
    const subaccount = merchant.subaccount.find((s: any) => s.id === subaccountId);
    return <>{subaccount ? subaccount.name : ""}</>;
  };

  const RoleActionsRenderer = (params: ICellRendererParams) => (
    <div className="flex items-center">
      <Tooltip title="Edit Role" arrow placement="top">
        <IconButton
          disabled={isDeleting || isDeleting}
          onClick={() => handleEditRole(params.data)}
          size="small"
        >
          <AiOutlineForm className="h-5 w-5 text-navy-700" />
        </IconButton>
      </Tooltip>
      {userRoles.length > 1 && (
        <>
          <Tooltip title="Unassign Role" arrow placement="top">
            <IconButton
              disabled={isDeleting || isDeleting}
              onClick={() => handleDeleteRole(params.data)}
              size="small"
            >
              <AiOutlineClose className="h-5 w-5 text-red-500" />
            </IconButton>
          </Tooltip>
        </>
      )}
    </div>
  );

  const columns: ColDef[] = [
    {
      field: "merchantName",
      headerName: "Merchant Name",
      flex: 1,
      sortable: false,
      cellRenderer: MerchantNameRenderer,
    },
    {
      field: "subaccountName",
      headerName: "Subaccount",
      flex: 1,
      sortable: false,
      cellRenderer: SubaccountNameRenderer,
    },
    {
      field: "role",
      headerName: "Role",
      minWidth: 200,
      sortable: false,
    },
    {
      field: "actions",
      headerName: "",
      width: 120,
      sortable: false,
      resizable: false,
      cellRenderer: RoleActionsRenderer,
      cellStyle: { display: "flex", alignItems: "center", justifyContent: "flex-end" },
    },
  ];

  interface UserStatusItems {
    status: string;
    value: string;
    display: ReactElement;
  }

  const statusClasses = "status";

  const statusList: UserStatusItems[] = [
    {
      status: "Inactive",
      value: "inactive",
      display: (
        <Badge className={`${statusClasses} status-inactive`}>Inactive</Badge>
      ),
    },
    {
      status: "Active",
      value: "active",
      display: (
        <Badge className={`${statusClasses} status-active`}>Active</Badge>
      ),
    },
    {
      status: "Disabled",
      value: "disabled",
      display: (
        <Badge className={`${statusClasses} status-disabled`}>Disabled</Badge>
      ),
    },
    {
      status: "Enabled",
      value: "enabled",
      display: (
        <Badge className={`${statusClasses} status-enabled`}>Enabled</Badge>
      ),
    },
    {
      status: "Setup Required",
      value: "setup_required",
      display: (
        <Badge className={`${statusClasses} status-setup-required`}>
          Setup Required
        </Badge>
      ),
    },
    {
      status: "First Sign-in Required",
      value: "first_sign_in_required",
      display: (
        <Badge className={`${statusClasses} status-first-sign-in-required`}>
          First Sign-in Required
        </Badge>
      ),
    },
    {
      status: "Forced Reset",
      value: "forced_reset",
      display: (
        <Badge className={`${statusClasses} status-forced-reset`}>
          Forced Reset
        </Badge>
      ),
    },
  ];

  const getDisplayStatus = (status: string) => {
    const statusItem = statusList.find((item) => item.status === status);
    return statusItem ? statusItem.display : null;
  };

  const defaultColDef = useMemo<ColDef>(
    () => ({
      resizable: true,
      suppressMenu: true,
    }),
    []
  );

  const CustomLoadingOverlay = () => (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }}>
      <CircularProgress size={40} />
    </div>
  );

  const handleUpdateStatus = (status: string) => {
    setStatusToUpdate(status);
    showUpdateStatusConfirmModal();
  };

  const showUpdateStatusConfirmModal = () => {
    setIsOpenUpdateStatusConfirmModal(true);
  };

  const closeUpdateStatusConfirmModal = () => {
    setIsOpenUpdateStatusConfirmModal(false);
  };

  const handleForceResetTwoFactor = () => {
    showResetTwoFactorConfirmModal();
  };

  const showResetTwoFactorConfirmModal = () => {
    setIsOpenResetTwoFactorConfirmModal(true);
  };

  const closeResetTwoFactorConfirmModal = () => {
    setIsOpenResetTwoFactorConfirmModal(false);
  };

  const handleUpdateTwoFactorStatus = (status: string) => {
    setTwoFactorStatusToUpdate(status);
    showUpdateTwoFactorStatusConfirmModal();
  };

  const showUpdateTwoFactorStatusConfirmModal = () => {
    setisOpenUpdateTwoFactorStatusConfirmModal(true);
  };

  const closeUpdateTwoFactorStatusConfirmModal = () => {
    setisOpenUpdateTwoFactorStatusConfirmModal(false);
  };

  const triggerReloadDetails = async () => {
    setIsLoading(true);
    await fetchUserDetail();
  };

  // Define tab configuration with conditional rendering based on user type
  const tabConfig = useMemo(() => {
    if (!userDetail) return [];

    const tabs = [{ label: "Details", show: true }];

    // Only show Accounts tab if user is not superadmin and not agent
    if (!userDetail.isSuperadmin && !userDetail.isAgent) {
      tabs.push({ label: "Accounts", show: true });
    }

    tabs.push({ label: "Access Control", show: true });

    return tabs;
  }, [userDetail]);

  // Filter visible tabs
  const visibleTabs = useMemo(() => {
    return tabConfig.filter((tab) => tab.show);
  }, [tabConfig]);

  // Render tab content based on label
  const renderTabContent = (label: string) => {
    switch (label) {
      case "Details":
        return (
          <>
            {isLoading && userDetail === null ? (
              <>
                <div
                  className="mb-3 h-5 animate-pulse rounded-md bg-gray-200"
                  style={{ animationDuration: "0.6s" }}
                ></div>
                <div
                  className="mb-3 h-5 animate-pulse rounded-md bg-gray-200"
                  style={{ animationDuration: "0.6s" }}
                ></div>
                <div
                  className="mb-3 h-5 animate-pulse rounded-md bg-gray-200"
                  style={{ animationDuration: "0.6s" }}
                ></div>
                <div
                  className="h-5 animate-pulse rounded-md bg-gray-200"
                  style={{ animationDuration: "0.6s" }}
                ></div>
              </>
            ) : (
              <>
                <div className="grid grid-cols-1 gap-x-8 gap-y-5 text-sm text-navy-700 dark:text-white md:grid-cols-2">
                  <div className="flex">
                    <label className="w-40 shrink-0">Username:</label>
                    <span className="font-semibold">{userDetail.username}</span>
                  </div>

                  {(userDetail.isSuperadmin || userDetail.isAgent) && (
                    <div className="flex">
                      <label className="w-40 shrink-0">Assigned Role:</label>
                      <span className="font-semibold">
                        {userDetail.isSuperadmin ? "Superadmin" : "Agent"}
                      </span>
                    </div>
                  )}

                  {userDetail.isAgent && (
                    <div className="flex">
                      <label className="w-40 shrink-0">Agent Name:</label>
                      <span className="font-semibold">
                        {userDetail.agentName}
                      </span>
                    </div>
                  )}
                  <div className="flex">
                    <label className="w-40 shrink-0">Created Date:</label>
                    <span className="font-semibold">
                      {formatDate(userDetail.created_date)}
                    </span>
                  </div>

                  <div className="flex">
                    <label className="w-40 shrink-0">Latest Login:</label>
                    <span className="font-semibold">
                      {userDetail.latest_login
                        ? formatDate(userDetail.latest_login)
                        : "-"}
                    </span>
                  </div>

                  <div className="flex">
                    <label className="w-40 shrink-0">Email *:</label>
                    <InputField
                      variant=""
                      extra="!w-[300px] -mt-[10px] mb-3 shadow-sm"
                      label=""
                      placeholder="Enter email"
                      id="email"
                      name="email"
                      type="email"
                      autoComplete="off"
                      value={updatedUser.email}
                      onChange={handleInputChange}
                      disabled={isUpdating || isProcessing}
                    />
                  </div>
                </div>

                <div className="flex justify-end pt-6">
                  <Button
                    onClick={handleUpdateUser}
                    className={`btn btn-primary !px-10 ${
                      isUpdating ? "pointer-events-none opacity-50" : ""
                    }`}
                    disabled={
                      isUpdating ||
                      isProcessing ||
                      !updatedUser.email ||
                      !isValidEmail(updatedUser.email)
                    }
                    isLoading={isUpdating}
                    loadingText="Updating User..."
                  >
                    Update
                  </Button>
                </div>
              </>
            )}
          </>
        );
      case "Accounts":
        return (
          <>
            <div className="mb-3 flex items-center justify-end">
              <Button
                isDisabled={isLoading || isDeleting || isProcessing}
                onClick={handleAddRole}
                className="btn btn-action !px-6"
              >
                <FaPlus />
                &nbsp;Add Role
              </Button>
            </div>
            <Box>
              <div style={{ width: "100%" }}>
                <AgGridReact
                  theme={themeAlpine}
                  rowData={
                    isLoading ||
                    userRoles.length === 0 ||
                    merchantForGetNameList.length === 0
                      ? []
                      : userRoles
                  }
                  columnDefs={columns}
                  defaultColDef={defaultColDef}
                  getRowId={(params) =>
                    `${params.data.role}-${params.data.merchantId}-${params.data.subaccountId}`
                  }
                  rowHeight={48}
                  headerHeight={44}
                  domLayout="autoHeight"
          suppressDragLeaveHidesColumns={true}
          enableCellTextSelection={true}
          ensureDomOrder={true}
                  suppressPaginationPanel={true}
                  loading={
                    isLoading ||
                    userRoles.length === 0 ||
                    merchantForGetNameList.length === 0
                  }
                  loadingOverlayComponent={CustomLoadingOverlay}
                  overlayNoRowsTemplate="No data available"
                />
              </div>
            </Box>
          </>
        );
      // Find this section in the "Access Control" tab (around line 700-800):

      case "Access Control":
        return (
          <>
            {isLoading && userDetail === null && currentUserRole ? (
              <>
                <div
                  className="mb-3 h-5 animate-pulse rounded-md bg-gray-200"
                  style={{ animationDuration: "0.6s" }}
                ></div>
                <div
                  className="mb-3 h-5 animate-pulse rounded-md bg-gray-200"
                  style={{ animationDuration: "0.6s" }}
                ></div>
                <div
                  className="mb-3 h-5 animate-pulse rounded-md bg-gray-200"
                  style={{ animationDuration: "0.6s" }}
                ></div>
                <div
                  className="h-5 animate-pulse rounded-md bg-gray-200"
                  style={{ animationDuration: "0.6s" }}
                ></div>
              </>
            ) : (
              <>
                <div className="flex">
                  <div className="mb-4 w-full rounded-lg border border-gray-200 bg-gray-50 p-4 dark:border-gray-700">
                    <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                      <div className="flex items-center gap-2">
                        <div className="w-[200px] text-sm text-navy-700 dark:text-white">
                          Activation Status :
                        </div>
                        {getDisplayStatus(userDetail.status)}
                      </div>
                      <div className="font-semibold">
                        {userDetail.status === "Active" && (
                          <Tooltip
                            title="Deactivate User"
                            arrow
                            placement="top"
                          >
                            <IconButton
                              disabled={
                                isUpdating ||
                                isProcessing ||
                                sysUsername === userDetail.username
                              }
                              id={"button-deactivate"}
                              onClick={() => handleUpdateStatus("inactive")}
                            >
                              <MdOutlineDoNotDisturbAlt className="h-6 w-6 text-red-500" />
                            </IconButton>
                          </Tooltip>
                        )}
                        {userDetail.status === "Inactive" && (
                          <Tooltip title="Activate User" arrow placement="top">
                            <IconButton
                              disabled={
                                isUpdating ||
                                isProcessing ||
                                sysUsername === userDetail.username
                              }
                              id={"button-activate"}
                              onClick={() => handleUpdateStatus("active")}
                            >
                              <AiOutlineCheckCircle className="h-6 w-6 text-primary-500" />
                            </IconButton>
                          </Tooltip>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex">
                  <div className="w-full rounded-lg border border-gray-200 bg-gray-50 p-4 dark:border-gray-700">
                    <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                      <div className="flex items-center gap-2">
                        <div className="w-[200px] text-sm text-navy-700 dark:text-white">
                          Two-Factor Authentication
                        </div>
                        {getDisplayStatus(
                          userDetail.userMFAStatus ? "Enabled" : "Disabled"
                        )}
                        {getDisplayStatus(
                          userDetail.is_force_reset_two_factor
                            ? "Forced Reset"
                            : ""
                        )}
                        {getDisplayStatus(
                          userDetail.is_force_reset_two_factor ||
                            userDetail.userMFAStatus
                        )
                          ? "Setup Required"
                          : ""}
                        {getDisplayStatus(
                          !userDetail.is_first_signin_completed
                            ? "First Sign-in Required"
                            : ""
                        )}
                      </div>
                      <div className="font-semibold">
                        <Tooltip title="Reset Two-Factor" arrow placement="top">
                          <IconButton
                            disabled={
                              isUpdating ||
                              isProcessing ||
                              userDetail.is_force_reset_two_factor ||
                              !userDetail.is_first_signin_completed ||
                              !userDetail.userMFAStatus
                            }
                            id={"button-reset-two-factor"}
                            onClick={handleForceResetTwoFactor}
                          >
                            <MdOutlineRestartAlt className="h-6 w-6 text-navy-700" />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <SweetAlert2 {...swalProps} />
      <>
        {isOpenUpdateStatusConfirmModal && (
          <UserUpdateStatusConfirmModal
            setSwalProps={setSwalProps}
            triggerReload={triggerReloadDetails}
            isOpen={isOpenUpdateStatusConfirmModal}
            onClose={() => closeUpdateStatusConfirmModal()}
            userToUpdate={userDetail}
            statusToUpdate={statusToUpdate}
          />
        )}
        {isOpenResetTwoFactorConfirmModal && (
          <UserResetTwoFactorConfirmModal
            setSwalProps={setSwalProps}
            triggerReload={triggerReloadDetails}
            isOpen={isOpenResetTwoFactorConfirmModal}
            onClose={() => closeResetTwoFactorConfirmModal()}
            userToUpdate={userDetail}
          />
        )}
        {isOpenUpdateTwoFactorStatusConfirmModal && (
          <UserUpdateTwoFactorStatusConfirmModal
            setSwalProps={setSwalProps}
            triggerReload={triggerReloadDetails}
            isOpen={isOpenUpdateTwoFactorStatusConfirmModal}
            onClose={() => closeUpdateTwoFactorStatusConfirmModal()}
            userToUpdate={userDetail}
            statusToUpdate={twoFactorStatusToUpdate}
          />
        )}
      </>
      <div className="flex h-full flex-col">
        <>
          <SweetAlert2 {...swalProps} />
          <Card className="card card-pad !rounded-xl">
            <div>
              <button
                type="button"
                onClick={() => navigate(`/${userRole}/user-management`)}
                className="
              mb-1 inline-flex items-center gap-1
              text-sm font-medium text-gray-700
              transition hover:text-gray-700
              disabled:cursor-not-allowed disabled:opacity-40
              dark:text-gray-400 dark:hover:text-white
            "
              >
                <FaAngleLeft className="text-base" />
                <span>Users</span>
              </button>

              <h3 className="text-xl font-semibold text-navy-700">
                User Management
              </h3>
            </div>
            <Tabs className="mt-3">
              {isLoading || !userDetail ? (
                <div className="p-7">
                  <div
                    className="mb-3 h-5 animate-pulse rounded-md bg-gray-200"
                    style={{ animationDuration: "0.6s" }}
                  ></div>
                  <div
                    className="mb-3 h-5 animate-pulse rounded-md bg-gray-200"
                    style={{ animationDuration: "0.6s" }}
                  ></div>
                  <div
                    className="mb-3 h-5 animate-pulse rounded-md bg-gray-200"
                    style={{ animationDuration: "0.6s" }}
                  ></div>
                  <div
                    className="h-5 animate-pulse rounded-md bg-gray-200"
                    style={{ animationDuration: "0.6s" }}
                  ></div>
                </div>
              ) : (
                <>
                  <TabList className="rounded-tl-custom rounded-tr-custom scrollbar-hide flex flex-wrap overflow-x-auto sm:flex-nowrap">
                    {visibleTabs.map((tab, index) => (
                      <Tab
                        key={index}
                        className={`child-tab rounded-tl-custom rounded-tr-custom sm:text-md whitespace-nowrap bg-white px-4 py-3 pt-4 text-sm text-navy-700 sm:px-6 sm:py-4 sm:pt-6 ${
                          !userDetail || isProcessing || isUpdating
                            ? "pointer-events-none opacity-50"
                            : ""
                        }`}
                      >
                        {tab.label}
                      </Tab>
                    ))}
                  </TabList>
                  <TabPanels className="rounded-bl-custom rounded-br-custom border-t border-gray-200 bg-white">
                    {visibleTabs.map((tab, index) => (
                      <TabPanel
                        key={index}
                        className={
                          tab.label === "Details" ||
                          tab.label === "Access Control"
                            ? "rounded-bl-custom rounded-br-custom px-4 py-8"
                            : "rounded-bl-custom rounded-br-custom px-4 py-8 pt-4"
                        }
                      >
                        {renderTabContent(tab.label)}
                      </TabPanel>
                    ))}
                  </TabPanels>
                </>
              )}
            </Tabs>
          </Card>

          {isOpenAddRoleModal && userDetail && (
            <AddRoleModal
              setSwalProps={setSwalProps}
              isOpen={isOpenAddRoleModal}
              onClose={closeAddRoleModal}
              userName={userDetail.username}
              userEmail={userDetail.email}
              roleOptions={roleOptions}
              merchants={merchants}
              getSubaccountOptions={getSubaccountOptions}
              isSetSubaccounts={isSetSubaccounts}
              fetchUserRoles={fetchUserRoles}
            />
          )}
          {isOpenEditRoleModal && userDetail && (
            <EditRoleModal
              setSwalProps={setSwalProps}
              isOpen={isOpenEditRoleModal}
              onClose={closeEditRoleModal}
              selectedRole={selectedRole}
              setUserRoles={setUserRoles}
              roleOptions={editRoleOptions}
              username={userDetail.username}
              email={userDetail.email}
              editUserChannel={editUserChannel}
              fetchUserRoles={fetchUserRoles}
              userRoles={userRoles}
              merchants={merchants}
              getSubaccountOptions={getSubaccountOptions}
              isSetSubaccounts={isSetSubaccounts}
              merchantForGetNameList={merchantForGetNameList}
            />
          )}
          {isOpenDeleteRoleModal && userDetail && (
            <DeleteRoleModal
              setSwalProps={setSwalProps}
              username={userDetail.username}
              email={userDetail.email}
              merchantName={deleteRoleMerchantName}
              subaccountname={deleteRoleSubaccountName}
              isOpen={isOpenDeleteRoleModal}
              onClose={closeDeleteRoleModal}
              selectedRole={selectedRole}
              setUserRoles={setUserRoles}
              editUserChannel={editUserChannel}
              fetchUserRoles={fetchUserRoles}
              setIsDeleting={setIsDeleting}
              userRoles={userRoles}
            />
          )}
        </>
      </div>
    </>
  );
};

export default UserDetail;
